<template>
    <div>
        <div class="container-guest container-login d-flex flex-column align-items-center">
            <img class="img-logo img-size" src="@/assets/images/logo.svg">
            <form class="w-100 d-flex flex-column align-items-center form-fnc form-padding" autocomplete="off" @submit.prevent="login">
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/au-icon-email.svg">
                    <input type="email" class="form-control" placeholder="Email" v-model="email" required>
                </div>

                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/au-icon-password.svg">
                    <input type="password" class="form-control" placeholder="Password" v-model="password" required>
                </div>

                <!--<b-link :to="{ name: 'forgotPassword' }" class="link-small align-self-end">-->
                   <!--<a class="one text">Forget Your Password?</a>-->
                <!--</b-link>-->

                <button type="submit" class="btn btn-block btn-fnc mt-1">
                    <img src="@/assets/images/ic_login.svg" class="img-ic-login" style="position: absolute;
                margin-left: -43px;">
                    LOG IN
                </button>
            </form>

            <div class="plainText" style="font-size: 15px" >
                Don't have an account?
                <b-link :to="{ name: 'register' }" >
                   <a class="text-green" href="#" >Sign Up Free</a>
                </b-link>
            </div>

            <div class="demo" style="margin-top: 30px; font-size: 14px">
                <p @click="tryDemo">Try our Full featured <a class="text-green" href="https://demo.financio.co" >Demo Financio</a> account today !</p>
            </div>

            <div class="wrp-footer-bg">
                <img src="@/assets/images/ic_bg_bottom.svg">
                <vapp-footer></vapp-footer>
            </div>
        </div>
        <div class="beta">
            <p class="beta-text">BETA</p>
        </div>
    </div>
</template>

<style>
    .beta {
        background: red;
        height: 30px;
        text-align: center;
        width: 170px;
        color: white;
        font-size: x-large;
        font-weight: bold;
        position: fixed;
        transform: rotate(45deg);
        right: -52px;
        top: 25px;
    }
    .form-padding {
        padding-top: 3rem !important;
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }
</style>


<script>
    import cryptojs from 'crypto-js';
    import authSvc from '../../services/authService';

    export default {
        data() {
            return {
                email: null,
                password: null,
                client_id: cryptojs.MD5( Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)).toString(),
                errored: false,
            }
        },
        mounted() {
            console.log("Mounted : Login");
        },
        methods: {
            login: function() {
                const { email, password, client_id } = this;
                authSvc.login({email,password,client_id});
            },
            tryDemo: function () {
                window.location = 'https://demo.financio.co';
            }
        }
    }
</script>
